export default {
    DECLARATOR_ONEOF: "oneOfProperty",
    GET_TEMPLATE_RECURSION_LIMIT: 1,
    propertyBlacklist: ["_id"],
    templateDefaultOptions: {
        addOptionalProps: false,
        removeInvalidData: false,
        extendDefaults: true
    }
};
